import { v4 as uuid } from 'uuid';
import { Customer } from '../../api/gql';
import { Contact } from './contact';

export type XmlCustomerData = Partial<Customer>;
export class XmlCustomer extends Contact {
  #details: XmlCustomerData;
  constructor(details: XmlCustomerData, invoiceId?: string) {
    super(details.id || uuid(), invoiceId);
    this.#details = details;
  }

  get details() {
    return this.#details;
  }
  set details(details) {
    this.#details = details;
  }
  hasContactInfo() {
    return !!this.details.phoneNumber && !!this.details.email;
  }
}
